
import React from "react";
import { Calendar, Info } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import AvailabilityDaySelector from "@/components/mentor/availability/AvailabilityDaySelector";
import TimeSlotManager from "@/components/mentor/availability/TimeSlotManager";
import AvailabilitySummary from "@/components/mentor/availability/AvailabilitySummary";
import CustomScrollbar from "@/components/mentor/availability/CustomScrollbar";
import { useAvailability, dayNames } from "@/hooks/useAvailability";

const Disponibilidade = () => {
  const {
    selectedDay,
    weeklySchedule,
    timeSlots,
    loading,
    savingDay,
    setTimeSlots,
    handleDaySelect,
    handleSaveTimeSlots
  } = useAvailability();

  // Get array of days that have schedules
  const scheduledDays = weeklySchedule.map(day => day.day);

  return (
    <div className="space-y-6">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <h1 className="text-3xl font-bold text-white flex items-center gap-2">
          <Calendar className="h-8 w-8 text-[#00B6F0]" />
          Configuração de Disponibilidade
        </h1>
        
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button variant="outline" className="flex items-center gap-2 bg-[#1A212E] border-[#2D3748] text-white hover:bg-[#2D3748]">
                <Info className="h-4 w-4 text-[#00B6F0]" />
                Como configurar
              </Button>
            </TooltipTrigger>
            <TooltipContent className="max-w-md p-4 bg-[#1A212E] border-[#2D3748] text-white">
              <div className="space-y-2">
                <p className="font-semibold">Configure sua disponibilidade em 3 passos:</p>
                <ol className="space-y-1 pl-4 list-decimal">
                  <li>Selecione um dia da semana</li>
                  <li>Configure os intervalos de horário para este dia</li>
                  <li>Salve os horários para o dia selecionado</li>
                </ol>
                <p className="text-xs text-gray-400 mt-2">Você pode configurar múltiplos intervalos para cada dia da semana.</p>
              </div>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
      
      <div className="grid grid-cols-1 lg:grid-cols-7 gap-6">
        {/* Left column - Day Selection */}
        <AvailabilityDaySelector 
          selectedDay={selectedDay}
          onDaySelect={handleDaySelect}
          scheduledDays={scheduledDays}
        />
        
        {/* Center column - Time Slot Management */}
        <TimeSlotManager 
          selectedDay={selectedDay}
          timeSlots={timeSlots}
          onTimeSlotsChange={setTimeSlots}
          onSaveTimeSlots={handleSaveTimeSlots}
          dayNames={dayNames}
          isSaving={savingDay}
        />
        
        {/* Right column - Availability Summary */}
        <AvailabilitySummary 
          weeklySchedule={weeklySchedule}
          selectedDay={selectedDay}
          dayNames={dayNames}
          loading={loading}
        />
      </div>
      
      <CustomScrollbar />
    </div>
  );
};

export default Disponibilidade;
